(() => {
  const ROOT_SELECTOR = '[data-coastd-feature]';

  function initialise(root) {
    if (!root || root.dataset.coastdFeatureReady === 'true') return;
    root.dataset.coastdFeatureReady = 'true';

    const productScript = root.querySelector('[data-coastd-feature-product]');
    if (!productScript) return;

    let product;
    try {
      product = JSON.parse(productScript.textContent);
    } catch (error) {
      console.warn('Coast’d anchored product: product data could not be read.', error);
      return;
    }

    const optionRoot = root.querySelector('[data-coastd-feature-options]');
    const addButton = root.querySelector('[data-coastd-feature-add]');
    const addLabel = root.querySelector('[data-coastd-feature-add-label]');
    const addPrice = root.querySelector('[data-coastd-feature-add-price]');
    const price = root.querySelector('[data-coastd-feature-price]');
    const errorMessage = root.querySelector('[data-coastd-feature-error]');
    const image = root.querySelector('.coastd-feature__image');
    const selections = {};
    let activeVariant = product.variants.find((variant) => variant.available) || product.variants[0];

    function cleanMoney(value) {
      const element = document.createElement('span');
      element.innerHTML = value || '';
      return element.textContent || '';
    }

    product.options.forEach((name, index) => {
      if (name === 'Title') return;
      const key = `option${index + 1}`;
      selections[key] = activeVariant?.[key] || '';

      const group = document.createElement('div');
      group.className = 'coastd-feature__option-group';

      const label = document.createElement('span');
      label.className = 'coastd-feature__option-label';
      label.textContent = name;

      const valuesWrap = document.createElement('div');
      valuesWrap.className = 'coastd-feature__option-values';
      const values = [...new Set(product.variants.map((variant) => variant[key]))];

      values.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'coastd-feature__option';
        button.textContent = value;
        button.dataset.optionKey = key;
        button.dataset.optionValue = value;
        button.setAttribute('aria-pressed', selections[key] === value ? 'true' : 'false');
        button.classList.toggle('is-selected', selections[key] === value);
        valuesWrap.appendChild(button);
      });

      group.append(label, valuesWrap);
      optionRoot.appendChild(group);
    });

    function matchingVariant() {
      return product.variants.find((variant) =>
        Object.entries(selections).every(([key, value]) => variant[key] === value)
      );
    }

    function refreshVariant() {
      activeVariant = matchingVariant();
      const available = Boolean(activeVariant?.available);

      addButton.disabled = !available;
      addLabel.textContent = available ? 'quick add' : 'sold out';

      if (activeVariant) {
        const formattedPrice = cleanMoney(activeVariant.price);
        price.textContent = formattedPrice;
        addPrice.textContent = formattedPrice;
        if (activeVariant.image && image) image.src = activeVariant.image;
      }

      optionRoot.querySelectorAll('.coastd-feature__option').forEach((button) => {
        const selected = selections[button.dataset.optionKey] === button.dataset.optionValue;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    const getCartRenderer = () =>
      document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    const getCartSections = (cartRenderer) => {
      if (cartRenderer && typeof cartRenderer.getSectionsToRender === 'function') {
        return cartRenderer.getSectionsToRender().map((section) => section.id);
      }

      return ['cart-icon-bubble', 'cart-drawer', 'cart-notification'];
    };

    const publishCartUpdate = (result) => {
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: `coastd-feature-${root.dataset.sectionId}`,
          productVariantId: activeVariant?.id,
          cartData: result
        });
      }
    };

    const refreshAndOpenCart = async (cartRenderer, addResult) => {
      const cartUrl = window.routes?.cart_url || '/cart';

      try {
        let sections = null;
        let parsedDrawer = null;

        for (let attempt = 0; attempt < 2; attempt += 1) {
          const separator = cartUrl.includes('?') ? '&' : '?';
          const response = await fetch(
            `${cartUrl}${separator}sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`,
            {
              cache: 'no-store',
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json'
              }
            }
          );

          if (!response.ok) throw new Error('Cart sections could not be refreshed.');
          sections = await response.json();
          parsedDrawer = new DOMParser().parseFromString(
            sections['cart-drawer'] || '',
            'text/html'
          ).querySelector('cart-drawer');

          if (parsedDrawer && !parsedDrawer.classList.contains('is-empty')) break;
          if (attempt === 0) await new Promise((resolve) => setTimeout(resolve, 180));
        }

        if (!parsedDrawer || parsedDrawer.classList.contains('is-empty')) {
          throw new Error('Shopify returned stale empty-cart markup.');
        }

        const currentDrawer = document.querySelector('cart-drawer');
        let freshDrawer = null;

        if (currentDrawer) {
          freshDrawer = parsedDrawer;
          currentDrawer.replaceWith(freshDrawer);
        }

        const currentBubble = document.querySelector('#cart-icon-bubble');
        const bubbleMarkup = sections['cart-icon-bubble'];

        if (currentBubble && bubbleMarkup) {
          const parsed = new DOMParser().parseFromString(bubbleMarkup, 'text/html');
          const freshBubble = parsed.querySelector('#cart-icon-bubble');
          if (freshBubble) currentBubble.replaceWith(freshBubble);
        }

        const updatedRenderer = freshDrawer || document.querySelector('cart-drawer');
        if (updatedRenderer && typeof updatedRenderer.open === 'function') {
          requestAnimationFrame(() => updatedRenderer.open());
        }

        return Boolean(updatedRenderer);
      } catch (error) {
        console.warn('Coast’d anchored product: full cart refresh failed.', error);

        if (cartRenderer && typeof cartRenderer.renderContents === 'function') {
          cartRenderer.renderContents(addResult);
          return true;
        }

        return false;
      }
    };

    optionRoot.addEventListener('click', (event) => {
      const button = event.target.closest('.coastd-feature__option');
      if (!button) return;
      selections[button.dataset.optionKey] = button.dataset.optionValue;
      refreshVariant();
    });

    addButton.addEventListener('click', async () => {
      if (!activeVariant?.available) return;

      addButton.disabled = true;
      addLabel.textContent = 'adding…';
      errorMessage.textContent = '';

      try {
        const cartRenderer = getCartRenderer();
        const sections = getCartSections(cartRenderer);
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: activeVariant.id,
            quantity: 1,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This item could not be added.');

        addButton.classList.add('is-added');
        addLabel.textContent = 'added to bag ✓';

        const cartWasRendered = await refreshAndOpenCart(cartRenderer, result);
        if (!cartWasRendered) {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { product, variant: activeVariant, result }
          }));
        }

        publishCartUpdate(result);

        if (!cartWasRendered) {
          const cartBubble = document.querySelector('#cart-icon-bubble');
          const bubbleMarkup = result.sections?.['cart-icon-bubble'];
          if (cartBubble && bubbleMarkup) {
            const parsed = new DOMParser().parseFromString(bubbleMarkup, 'text/html');
            const freshBubble = parsed.querySelector('#cart-icon-bubble');
            if (freshBubble) cartBubble.innerHTML = freshBubble.innerHTML;
          }
        }
      } catch (error) {
        errorMessage.textContent = error.message;
        addLabel.textContent = 'quick add';
      } finally {
        addButton.disabled = false;
      }
    });

    refreshVariant();
  }

  function initialiseAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
